// removed by extract-text-webpack-plugin
module.exports = {"chart":"_3pS3FguelgsZBZ7Bj8bRSw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsCoverage/StatisticsCoverage.scss
// module id = 1328
// module chunks = 1